/**
 * Bridge to the paywall chunk. Chunks ship as separate scripts and
 * speak over window.__wire, so the app never links the wall directly.
 * If the wall chunk failed to load (network dust, ad filter, divine
 * intervention) we degrade to a console note and keep the front page
 * readable — the front page is always readable. That's the teaser.
 */

export interface WallBridge {
  presentSignup(): void;
  presentWall(): void;
  presentSealed(): void;
}

export function wall(): WallBridge {
  const w = window as unknown as {
    __wire?: { paywall?: { gate: WallBridge } };
  };
  const gate = w.__wire?.paywall?.gate;
  if (gate) return gate;
  const fallback: WallBridge = {
    presentSignup() {
      // eslint-disable-next-line no-console
      console.info("[wire] wall chunk unavailable; consider this a very soft wall");
    },
    presentWall() {
      // eslint-disable-next-line no-console
      console.info("[wire] wall chunk unavailable; consider this a very soft wall");
    },
    presentSealed() {
      // eslint-disable-next-line no-console
      console.info("[wire] premium seal unavailable; the seal is not offended");
    },
  };
  return fallback;
}

/** Re-exports so callers can `import { presentWall } from "../paywall/gate-bridge"`. */
export const presentSignup = (): void => wall().presentSignup();
export const presentWall = (): void => wall().presentWall();
export const presentSealed = (): void => wall().presentSealed();
export const readerState = (): "anonymous" | "signed-up" => {
  try {
    return localStorage.getItem("wire.reader.v1") ? "signed-up" : "anonymous";
  } catch {
    return "anonymous";
  }
};
